import { TableSorting, UserTrackingHistory } from '@src/types'
import { api, ApiRes } from '@src/utils/api/client'
import { AxiosRequestConfig } from 'axios'

export interface UserTrackingResponse {
    success: boolean
    user_tracking_history: UserTrackingHistory[]
    user_tracking_history_count: number
}

export const getUserTracking = (
    filters?: Record<string, unknown>,
    sorting?: TableSorting[],
    page?: number,
    limit?: number
): ApiRes<UserTrackingResponse> => {
    const config: AxiosRequestConfig = {}

    config.params = {}

    if (filters && Object.keys(filters).length) {
        config.params = filters
    }

    if (typeof page === 'number' && typeof limit === 'number') {
        config.params['range'] = page * limit - limit + '-' + page * limit
    }

    if (sorting && sorting.length) {
        config.params['sort'] = sorting
            .map((sort) => {
                return (sort.direction === 'desc' ? '-' : '') + sort.field
            })
            .join(',')
    }
    return api.get('/manage/user-tracking', config)
}
